import { take, call, put, select, race } from 'redux-saga/effects';
import { changeCurrentMediaSource, setCurrentFolderId, fetchMoreGallections, fetchMoreGallectionsDone, reloadStashStreamDone } from '../actions';
import { STREAM__WITH_OFFSET__FETCH_SUCCESS, STREAM__WITH_OFFSET__FETCH_SUCCESS_DEDUPE } from '../../Stream/withOffset/actions';
import { getCurrentMediaSource, getTopLevelGallections, getCurrentFolderId } from '../selectors';
import { getGallectionDeviationStreamId } from '../helpers';
import { withOffset } from '../../Stream';
import { MediaSourceType } from '../types';
function* getOrLoadGallections() {
    let gallections = yield select(getTopLevelGallections);
    if (!gallections || gallections.length === 0) {
        // gallections for the currentMediaSource have not yet been loaded, load them
        yield put(fetchMoreGallections());
        // wait for a fetch more gallections to complete
        let done = false;
        while(!done){
            var _payload;
            const { payload } = yield take(fetchMoreGallectionsDone);
            done = ((_payload = payload) === null || _payload === void 0 ? void 0 : _payload.type) === MediaSourceType.STASH;
        }
        gallections = yield select(getTopLevelGallections);
    }
    return gallections;
}
export function* reloadStashStream() {
    const currentMediaSource = yield select(getCurrentMediaSource);
    let currentFolderId = yield select(getCurrentFolderId);
    if (currentMediaSource !== MediaSourceType.STASH) {
        // change the media source to stash
        yield put(changeCurrentMediaSource(MediaSourceType.STASH));
        const gallections = yield call(getOrLoadGallections);
        if (!gallections.length) {
            // still no folders? everything is terrible, let's crash gracefully
            yield put(reloadStashStreamDone());
            return;
        }
        // First stash folder is the "Featured" folder which contains items uploaded to the stash root
        currentFolderId = gallections[0].folderId;
    }
    if (currentFolderId) {
        // If the user did not have any items in stash, and the stash gallections were
        // cached, we need to uncache the stream in order to get the fresh items
        const streamId = getGallectionDeviationStreamId(MediaSourceType.STASH, currentFolderId);
        yield put(withOffset.actions.deleteStream(streamId));
        // Load this folder id
        yield put(setCurrentFolderId(currentFolderId));
        // wait for a stash fetch success event
        let done = false;
        while(!done){
            var _fetchSuccess, _fetchSuccessDeduped;
            const { fetchSuccess, fetchSuccessDeduped } = yield race({
                fetchSuccess: take(STREAM__WITH_OFFSET__FETCH_SUCCESS),
                fetchSuccessDeduped: take(STREAM__WITH_OFFSET__FETCH_SUCCESS_DEDUPE)
            });
            const actionStreamId = ((_fetchSuccess = fetchSuccess) === null || _fetchSuccess === void 0 ? void 0 : _fetchSuccess.streamId) || ((_fetchSuccessDeduped = fetchSuccessDeduped) === null || _fetchSuccessDeduped === void 0 ? void 0 : _fetchSuccessDeduped.streamId);
            done = actionStreamId === streamId;
        }
    }
    yield put(reloadStashStreamDone());
}
export default reloadStashStream;
